import { Grid, GridProps } from '@mui/material';
import React from 'react';
import AttachmentCard from 'components/common/Chats/AttachmentCard';
import type { AttachmentsType } from '.';

type PromptAttachmentsProps = {
  attachments?: AttachmentsType[];
  onAttachmentRemove?: (
    cardType: AttachmentsType['type'],
    id: AttachmentsType['id']
  ) => void;
  containerStyle?: GridProps['style'];
};

function PromptAttachments({
  attachments = [],
  onAttachmentRemove,
  containerStyle = {},
}: PromptAttachmentsProps) {
  return (
    <>
      {!!attachments?.length && (
        <Grid
          container
          item
          gap={2}
          paddingY={1}
          px='14px'
          flexWrap='nowrap'
          sx={{ overflowX: 'auto', scrollbarWidth: 'none', ...containerStyle }}
        >
          {attachments?.map((card, idx) => (
            <AttachmentCard
              key={idx}
              cardType={'file'}
              thumbnail={card.thumbnail}
              fileTypeTag={card.fileTypeTag}
              file={null}
              title={card.title || ''}
              isUploading={false}
              details={card.details || ''}
              maxWidth='250px'
              minWidth='150px'
              isRemovable={card.type === 'memory' ? false : true}
              onClick={() => {}}
              onClose={() => {
                onAttachmentRemove && onAttachmentRemove(card.type, card.id);
              }}
              isChatAttachment={false}
            />
          ))}
        </Grid>
      )}
    </>
  );
}

export default React.memo(PromptAttachments);
